import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconInitial } from '../../../assets/icons/icon-initial';
import { Checkbox } from '../../../components';
import { useUserProfileStore } from '../../../store/user-profile';

type UserInitialProps = {
  setUseUserInitial: (value: boolean) => void;
  useUserInitial: boolean;
  disabled: boolean;
};

const UserInitial: React.FC<UserInitialProps> = ({ setUseUserInitial, useUserInitial, disabled }) => {
  const { t } = useTranslation('profile');
  const { userInitial } = useUserProfileStore((s) => s.meData);

  return (
    <div className="edit-avatar__option">
      <span className="edit-avatar__option-header">{t('avatar.optionName.header')}</span>
      <div className="edit-avatar__input edit-avatar__input--checkbox">
        <Checkbox
          isFullWidth
          onChange={(event) => setUseUserInitial(event.target.checked)}
          checked={useUserInitial}
          disabled={disabled}
        >
          <div className="edit-avatar__input--left">
            <IconInitial initial={userInitial} />
            <span className="m-l-24">{t('avatar.optionName.label')}</span>
          </div>
        </Checkbox>
      </div>
    </div>
  );
};
export default UserInitial;
